<template>
  <div :class="{ alt: isHomePage }" class="header" id="header">
    <div :class="{ open: showMenu }" class="top" id="top">
      <div class="inner">
        <page-link to="/">
          <img alt="SPJ Marketing Doncaster" class="logo" src="../assets/spj.jpg" />
        </page-link>
        <a @click.prevent="showMenu = !showMenu" class="mobile-menu" href id="mobile-menu-btn">
          <font-awesome-icon icon="bars" v-show="!showMenu" />
          <font-awesome-icon icon="times" v-show="showMenu" />
        </a>
        <nav class="nav">
          <ul v-if="main_pages">
            <li :key="menu_page.ItemID" v-for="menu_page in main_pages">
              <template v-if="menu_page.ItemID == servicesID">
                <router-link
                  class="serviceslink"
                  :to="'/'"
                  @click.native="
                    showMenu = false
                    scrollFix('#services')
                  "
                  >{{ menu_page.name }}</router-link
                >
              </template>
              <template v-else>
                <page-link :to="menu_page.url || '/'">{{ menu_page.name }}</page-link>
              </template>

              <ul v-if="menu_page.ItemID == servicesID && menu_page.subs">
                <li :key="sub_page.ItemID" v-for="sub_page in menu_page.subs">
                  <page-link :to="sub_page.url">{{ sub_page.name }}</page-link>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <div class="banners">
      <!-- <div class="slideshow">
        <img :alt="image.alt" :key="image._id" :src="image.image" v-for="image in page.banners" />
      </div> -->
      <div class="slideshow" v-if="randomBanner">
        <img class="loading" src="/banner_loading.gif" alt="loading" />
        <div><img :alt="randomBanner.alt" :key="randomBanner._id" :src="randomBanner.image" /></div>
      </div>
      <div class="shadow"></div>
      <div class="slogan">
        <div class="inner">
          <div class="welcome">{{ page.heading_1 }}</div>
          <div>{{ page.heading_2 }}</div>
        </div>
      </div>
    </div>
    <div class="breadcrumb">
      <div class="inner">
        <router-link to="/">Home</router-link>&nbsp;
        <template v-if="parent_page">
          <span><font-awesome-icon icon="chevron-right"/></span>
          <page-link :to="parent_page.url">{{ parent_page.name }}</page-link></template
        >
        <template v-if="!isHomePage">
          <span><font-awesome-icon icon="chevron-right"/></span>
          <page-link :to="page.url">{{ page.name }}</page-link></template
        >
        <a class="a-quote" v-if="isAService || isSchoolsPage" href @click.prevent="scrollFixInstant('#formanchor')"
          ><font-awesome-icon icon="arrow-right" /> Request a free quote</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex"

var VueScrollTo = require("vue-scrollto")

var options = {
  container: "body",
  easing: "ease-in",
  offset: -100,
  force: true,
  cancelable: true,
  onStart: function() {
    // scrolling started
  },
  onDone: function() {
    // scrolling is done
  },
  onCancel: function() {
    // scrolling has been interrupted
  },
  x: false,
  y: true
}

export default {
  data: function() {
    return {
      showMenu: false
    }
  },
  computed: {
    ...mapState(["page", "main_pages", "servicesID", "parent_page"]),
    ...mapGetters(["isHomePage", "isAService", "isSchoolsPage"]),
    randomBanner() {
      if (!this.page) return null
      if (!this.page.banners) return null
      if (!this.page.banners.length) return null

      return this.page.banners[Math.floor(Math.random() * this.page.banners.length)]
    }
  },
  methods: {
    scrollFix: function(hash) {
      setTimeout(() => VueScrollTo.scrollTo(hash, 500, options), 500)
    },
    scrollFixInstant: function(hash) {
      VueScrollTo.scrollTo(hash, 500, options)
    }
  }
}
</script>

<style scoped>
.header {
  position: relative;
}
.top {
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  transition: all 1s;
  height: 10rem;
}
.top.contrast {
  background: black;
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.75);
}

.logo {
  width: 15rem;
  position: absolute;
  left: 0;
  top: 0;
  transition: all 1s;
}
.top.contrast .logo {
  width: 10rem;
}
.banners {
  position: relative;
  z-index: 1;
}
.banners .shadow {
  box-shadow: inset 0px 0px 400px 0px rgba(0, 0, 0, 1);
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2;
  top: 0;
  left: 0;
}
.banners img {
  display: block;
  margin: auto;
}
.slideshow {
  position: relative;
}
.slideshow > div {
  position: absolute;
  top: 0;
  left: 0;
}

.slogan {
  position: absolute;
  bottom: 7rem;
  left: 0;
  z-index: 3;
  color: white;
  font-size: 7rem;
  width: 100%;
  text-shadow: 0px 0px 30px rgba(0, 0, 0, 0.75);
}
.alt .slogan {
  font-size: 6rem;
}
.welcome {
  color: #c1d62f;
}

.nav ul,
.nav ul li {
  list-style: none;
  padding: 0;
  margin: 0;
  display: inline-block;
}
.top.contrast .nav {
  top: 4rem;
}
.nav {
  position: absolute;
  top: 9rem;
  right: 0;
  font-size: 2.5rem;
  transition: all 1s;
}
.nav ul li {
  margin-left: 3rem;
  position: relative;
}
.nav ul ul {
  display: none;
  width: 20rem;
  text-align: left;
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 2rem;
  left: -2rem;
  z-index: 1;
  background: rgba(0, 0, 0, 0.603);
  font-size: 2.2rem;
}
.nav ul ul li {
  margin-left: 0;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  display: block;
}

.nav a {
  transition: all 0.3s;
  text-shadow: 0px 0px 30px rgba(0, 0, 0, 0.75);
}
.nav a:hover {
  color: #c1d62f;
}

.mobile-menu {
  display: none;
}

.serviceslink {
  cursor: default !important;
}

.breadcrumb {
  background: #c1d62f;
  padding: 1.5rem 0;
  color: black;
  font-size: 2rem;
  position: relative;
}

.breadcrumb span {
  display: inline-block;
  padding: 0 0.75rem;
  font-size: 1rem;
  color: white;
  position: relative;
  top: -0.25rem;
}
.a-quote {
  background: white;
  top: -1.5rem;
  right: 0;
  position: absolute;
  font-size: 3.5rem;
  padding: 1.5rem 3rem;
  transition: all 0.3s;
  box-shadow: inset 0px 7px 15px 5px rgba(0, 0, 0, 0.1);
}
.a-quote svg {
  margin-right: 1rem;
  transition: all 0.3s;
  animation: bounceRight 2s infinite;
}
.a-quote:hover {
  padding: 1.5rem 4rem;
  box-shadow: inset 0px 7px 15px 5px rgba(0, 0, 0, 0.2);
}
.a-quote:hover svg {
  color: #c1d62f;
}

@keyframes bounceRight {
  0%,
  20%,
  50%,
  80%,
  100% {
    -ms-transform: translateX(0);
    transform: translateX(0);
  }
  40% {
    -ms-transform: translateX(-1rem);
    transform: translateX(-1rem);
  }
  60% {
    -ms-transform: translateX(-0.5rem);
    transform: translateX(-0.5rem);
  }
}

@media screen and (min-width: 980px) {
  .nav ul li:hover ul {
    display: block;
    position: absolute;
  }
}

@media screen and (max-width: 980px) {
  .a-quote {
    font-size: 2rem;
    clip-path: none;
  }
  .nav {
    transform: scale(10);
    position: fixed;
    width: 100%;
    height: 100vh;
    background: black;
    z-index: 11;
    top: 0;
    padding: 20vh 0;
    transition: all 0.3s;
    pointer-events: none;
    opacity: 0;
  }
  .mobile-menu {
    display: block;
    position: absolute;
    right: 0;
    top: 4rem;
    font-size: 4rem;
    transition: all 0.3s;
    z-index: 12;
  }
  .open .mobile-menu,
  .contrast .mobile-menu,
  .open.contrast .mobile-menu {
    top: 3rem !important;
  }
  .slogan {
    bottom: 3rem;
    font-size: 5rem;
  }
  .open .nav {
    transform: scale(1);
    pointer-events: all;
    opacity: 1;
    top: 0 !important;
  }
  .nav ul {
    width: 100%;
  }
  .nav ul li,
  .nav ul li a {
    margin-left: 0;
    display: block;
    width: 100%;
    text-align: center;
    height: 10vh;
  }
}
@media screen and (max-width: 800px) {
  .banners {
    overflow: hidden;
  }
  .banners img {
    width: 150%;
    max-width: none;
    left: -25%;
  }
}
@media screen and (max-width: 650px) {
  .a-quote {
    display: none;
  }
  .top .logo {
    width: 10rem;
  }
  .top {
    height: 7rem;
  }
  .top.contrast .logo {
    width: 7rem;
  }
  .contrast .mobile-menu {
    top: 1.25rem;
  }
  .open .mobile-menu,
  .contrast .mobile-menu,
  .open.contrast .mobile-menu {
    top: 1.25rem !important;
  }
  .slogan {
    font-size: 3.5rem;
  }
}
@media screen and (max-width: 500px) {
  .banners img {
    width: 300%;
    left: -75%;
  }
}
</style>
